firebird.factory('videoPublishService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'socketService',
    'helperService',
    'configService',
    'localStreamManagerService',
    'avDeviceService',
    'storageService',
    'analyticsWrapperService',
    'localizationService',
    'videoFilterService',
    'videoGlobalService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        logService,
        attendeeService,
        connectivityService,
        socketService,
        helperService,
        configService,
        localStreamManagerService,
        avDeviceService,
        storageService,
        analyticsWrapperService,
        localizationService,
        videoFilterService,
        videoGlobalService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoPublishService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // videoroom plugin handle
            self.videoroom = null;

            // display name for publisher
            self.myusername = null;

            // whether it is re-publishing, so should not cleanup local video and call.
            self.republishing = false;

            // this participant's videoroom ID
            self.myid = null;

            // this participant's videoroom publishing stream (local media stream)
            self.mystream = null;

            // this participant's publisher ID
            self.mypvtid = null;

            self.pendingPublishAttach = false;

            self.startVideoPublish = startVideoPublish;
            self.stopVideoPublish = stopVideoPublish;

            self.createOfferForVideo = createOfferForVideo;
            self.createOfferInternal = createOfferInternal;
            self.createOfferOrRepublish = createOfferOrRepublish;
            self.republishAfterSimulcastChanged = republishAfterSimulcastChanged;

            // store a pending createOfferForVideo request to be called after previous unpublish is completed.
            // TODO: we may need an array of pending requests.
            self.pendingCreateOfferForVideo = null;

            self.onErrorUserIdAlreadyExists = onErrorUserIdAlreadyExists;
            self.getVideoPublishRegisterObj = getVideoPublishRegisterObj;
            self.checkRoomExistsAndJoin = checkRoomExistsAndJoin;
            self.joinVideoPublisherToRoom = joinVideoPublisherToRoom;

            self.isVideoPublishOfferPending = false; // is true after vunmute and until offer is created, so that sendRestartVideo can be set/reset accordingly.

            self.timerCheckRoomExists = null; // pending check timer
            self.timerCheckRoomExistsScreen = null;
            self.timeoutCheckRoomExists = 3000; // timeout in ms

            self.videoRepublishRetry = 0;
            self.videoRepublishMaxRetries = 10;
            self.videoRepublishTimer = null;
            self.cancelVideoRepublishTimer = cancelVideoRepublishTimer;
            self.handleVideoPublishPluginError = handleVideoPublishPluginError;
            self.recreateVideoPublishPlugin = recreateVideoPublishPlugin;

            self.fixWebcamButtonState = configService.getValue('fixWebcamButtonState') === 'true';
            self.videoPublishState = {
                button: false, // button is clickable if false.
                server: false // waiting for node server response is true.
            };
            self.setVideoPublishState = setVideoPublishState;
            self.sendVideoMute = sendVideoMute;

            // When the camera button is toggled
            $scope.$on('start-sfu-videopublish', onStartSfuVideoPublish);
            $scope.$on('stop-sfu-videopublish', onStopSfuVideoPublish);

            // for backward compatibility (remove later)
            $scope.$on('update-meeting-active-feed', onUpdateMeetingActiveFeed);

            // video filter changed in settings
            $scope.$on('video-filter-changed', onVideoFilterChanged);

            //Virtual Background Loading Message
            self.vbLoadingMsg = localizationService.translate('HEADER.SETTINGS.LOADING');
            self.getContentShareErrorMessage = getContentShareErrorMessage;
        }

        // To leave the video room as a publisher, send the leave request, and detach the
        // plugin handle.
        function stopVideoPublish() {
            logService.log('stopVideoPublish ...');
            if (self.pendingSimulcastEncodings) {
                self.pendingSimulcastEncodings = null;
            }

            if (self.timerCheckRoomExists) {
                $timeout.cancel(self.timerCheckRoomExists);
                self.timerCheckRoomExists = null;
            }

            // cancel adjust video publisher bandwidth
            self.cancelAdjustVideoPublishBandwidth();

            if (self.videoroom) {
                self.iceRestartCancel(self.videoroom);
                self.detachPlugin(self.videoroom);
                self.videoroom = null;
                self.myid = null;
                self.mypvtid = null;
            }

            if (self.sendRestartVideo) {
                self.sendRestartVideo = false;
            }

            if (self.mediapath != 'sfu') {
                // if mediapath is 'sfu', send unvmute on UI action.
                attendeeService.setIsVideoMuted(true);
                self.sendVideoMute(true);
            } else {
                self.willSwitchDevice = false;
                avDeviceService.setIsMicrophoneDeviceSwitching(false);
            }

            self.cancelVideoRepublishTimer();
            self.resetPublishVideoLow();
            connectivityService.resetSentVideoPL();
        }

        // To join the video room as a publisher, attach to the videoroom plugin, then join as a publisher,
        // and send information about local publishing stream offer. Also process all the incoming events
        // and messages from the video room plugin about this publisher.
        function startVideoPublish() {
            if (self.layoutPage && self.pendingPublishAttach) {
                // do not use self.videoroom check here for backward compatibility.
                logger.log('startVideoPublish', 'publisher attach ignored, as previous request is pending');
                self.msgflowEvent('publish:attach:error', { reason: 'previous pending' });
                return;
            }

            analyticsWrapperService.eventTrack('Meeting - video publish - starting', { sfuEvent: true });
            var plugin = null;

            self.qualityLimitation.count = 0; // reset on start.
            self.qualityLimitation.base = 0;

            self.pendingPublishAttach = true;
            self.janus.attach({
                plugin: self.newplugin ? 'janus.plugin.anymeeting' : 'janus.plugin.videoroom',
                handle_type: 'videoroom',
                opaqueId: self.opaqueId,
                success: function (pluginHandle) {
                    self.pendingPublishAttach = false;
                    self.videoroom = plugin = pluginHandle;
                    logger.log(
                        'startVideoPublish->janus.attach.success',
                        'publisher plugin attached! (' +
                            self.videoroom.getPlugin() +
                            ', id=' +
                            self.videoroom.getId() +
                            ')'
                    );

                    analyticsWrapperService.eventTrack('Meeting - video publish - connected', { sfuEvent: true });

                    self.videoroom.state = {};
                    self.videoroom.state.call = 'starting';

                    // first check if the room exists. If not, wait to retry, may be node server was restarted.
                    self.roomCreationRequested = false;
                    self.checkRoomExistsAndJoin();
                },
                error: function (error) {
                    logger.error('startVideoPublish->janus.attach.error', 'error attaching videoroom plugin...', error);
                    analyticsWrapperService.eventTrack('Meeting - video publish - error', { sfuEvent: true });

                    self.pendingPublishAttach = false;

                    if (error && typeof error.indexOf === 'function' && error.indexOf('Is the server down?') > -1) {
                        self.setVideoPublishState('button', false);
                    }

                    if (self.shouldReattachPluginAfterError(error)) {
                        $timeout(() => self.recreateVideoPublishPlugin(), 0);

                        // videoConnectService.coreError will not be called
                        return true;
                    }

                    return false;
                },
                mediaState: function (medium, on) {
                    logService.log(
                        'videoroomCtrl videoroom ' + (on ? 'started' : 'stopped') + ' receiving our ' + medium
                    );
                    plugin.state.media = !!on;

                    if (on) {
                        self.videoRepublishRetry = 0;
                        self.cancelVideoRepublishTimer();

                        if (self.isSimulcastTogglePhaseSwitching()) {
                            // media is flowing => possible simulcast toggling is completed
                            self.markSimulcastTogglePhaseAsDone();
                        }
                    }

                    if (on && !plugin.state.mediaInitiated) {
                        plugin.state.mediaInitiated = self.iceMediaInitiated = true;
                    }

                    if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix && medium === 'video') {
                        // Maintain active state of the local stream in the meeting.
                        // On VDI - the same local stream is shown in the settings modal and preview if stream is active.
                        attendeeService.setIsVideoActive(!!on);
                    }

                    if (on && self.pendingSimulcastEncodings) {
                        // apply any pending simulcast encodings here. only applicable for simulcast2.
                        var fpsChange = self.pendingSimulcastEncodings.fpsChange;
                        self.pendingSimulcastEncodings = null;
                        logService.log('videoroomCtrl - reapplySimulcastEncodings from pending fpsChange=' + fpsChange);
                        $timeout(function () {
                            self.reapplySimulcastEncodings(fpsChange);
                        });
                    }
                },
                iceState: function (state) {
                    logService.log('videoroomCtrl videoroom publisher iceState ' + state);

                    plugin.state.ice = state;

                    var plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log(
                            'videoroomCtrl publish, ignoring iceState ' + state + ' as not for current plugin'
                        );
                        self.iceRestartCancel(plugin);
                        return;
                    }

                    if (self.republishing) {
                        // do not alter the state or do restart, if republishing.
                        logService.log('videoroomCtrl iceState is ignored during republishing');
                    } else {
                        connectivityService.updateJanusIceState(state, 'publisher');

                        if (state == 'disconnected') {
                            self.iceRestartAfter(self.videoroom, 'video-send');
                        }
                    }

                    if (state === 'connected') {
                        if (self.videoroom) {
                            self.iceRestartCancel(self.videoroom);
                        }
                        if (self.videoroom && self.videoroom.webrtcStuff) {
                            logService.log('videoroomCtrl applying getStats to outgoing video peer connection');
                            self.applyGetStats(self.videoroom.webrtcStuff.pc, connectivityService.callMediaTypes.SFU, {
                                transmissionType: 'sent',
                                mediaType: 'video'
                            });
                        }
                    }
                },
                webrtcState: function (on, reason) {
                    logService.log(
                        'videoroomCtrl videoroom says our WebRTC PeerConnection is ' +
                            (on ? 'up' : 'down') +
                            ' now, reason=' +
                            reason
                    );

                    plugin.state.webrtc = !!on;

                    var plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log(
                            'videoroomCtrl publish, ignoring webrtcState ' + on + ' as not for current plugin'
                        );
                        return;
                    }

                    self.sendStatsUpdate(on, plugin);
                },
                slowLink: function (uplink, lost) {
                    var plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl publish, ignoring slowLink as not for current plugin');
                        return;
                    }

                    if (!uplink) {
                        self.onSlowLink('video', true, lost);
                    }
                },
                onmessage: function (msg, jsep) {
                    logger.log(
                        'startVideoPublish->janus.attach.onmessage',
                        'videoroom publisher message received',
                        msg
                    );

                    var event = msg.anymeeting || msg.videoroom || msg.sip;
                    var plugin0 = self.videoroom;

                    if (event == 'joined') {
                        // client has joined the video room, so it can now publish the local stream.
                        // currently we send only video to the video room plugin.
                        self.myid = msg.id;
                        self.mypvtid = msg.private_id;
                        logService.log('videoroomCtrl videoroom joined room ' + msg.room + ' with ID ' + self.myid);

                        self.videoroom.state.call = 'joined';

                        // for video, sip call is done first, and must be informed about this video publisher,
                        // so that the plugin can forward the video from this publisher in the sip call.
                        if (self.sendVideoToFS) {
                            self.attachVideoRoomToSIP(true);
                        }

                        // add or remove the video track when video is enabled or disabled.
                        // without this, blank video is still sent to the server.

                        self.msgflowEvent('peer-connection:joined', { type: 'video-send', reason: 'joined' });
                        self.createOfferForVideo(true);
                    } else if (event == 'destroyed') {
                        logger.error(
                            'startVideoPublish->janus.attach.onmessage',
                            'videoroom the room has been destroyed!'
                        );
                    } else if (event == 'event') {
                        if (msg.publishers) {
                            logService.log('videoroomCtrl videoroom got a list of available publishers/feeds:');
                        } else if (msg.leaving) {
                            logService.log('videoroomCtrl videooroom Publisher left: ' + msg.leaving);
                        } else if (msg.configured) {
                            if (!self.pendingCreateOfferForVideo) {
                                plugin._configured = true; // indicates other messages for bitrate control can be sent.
                                if (self.sendVideoToFS && self.republishing && msg.configured == 'ok') {
                                    self.attachVideoRoomToSIP(true);
                                }
                                if (self.republishing) {
                                    self.republishing = false;
                                }
                                if (msg.configured == 'ok') {
                                    plugin.state.call = 'started';
                                }
                                if (msg.configured == 'ok' && self.sendRestartVideo) {
                                    // inform all the other attendees to restart our screen video feed.
                                    self.sendRestartVideo = false;
                                    self.sendRestartVideoPlay();
                                }
                            } else {
                                logService.log(
                                    'videoroomCtrl videoroom publisher ignore configured since pending unpublish'
                                );
                                if (jsep) {
                                    // do not handle SDP even if present.
                                    jsep = null;
                                }
                            }
                        } else if (msg.unpublished) {
                            logService.log('videoroomCtrl videoroom Publisher left: ' + msg.unpublished);
                            if (msg.unpublished == 'ok') {
                                delete plugin._configured;
                                // if local publisher lefts, leave the video room.
                                // but not if this is republishing state, in which case do not explicitly hangup.
                                plugin.state.call = 'stopped';
                                if (!self.republishing) {
                                    logService.log('videoroomCtrl videoroom publisher sending hangup');
                                    plugin.hangup();
                                }
                                return;
                            }
                            var remoteFeed1 = self.feeds[msg.unpublished] || null;
                            if (remoteFeed1 != null) {
                                logService.log(
                                    'videoroomCtrl videoroom feed ' +
                                        remoteFeed1.rfid +
                                        ' (' +
                                        remoteFeed1.rfdisplay +
                                        ') has left the room'
                                );
                            }
                        } else if (msg.error) {
                            if (!plugin0 || plugin !== plugin0) {
                                logger.warn(
                                    'startVideoPublish->janus.attach.onmessage',
                                    'ignoring error as not for current plugin',
                                    msg
                                );
                                return;
                            }

                            logger.error('startVideoPublish->janus.attach.onmessage', 'videoroom error received', msg);

                            // check for backward compatibility. could be removed after some time.
                            if (
                                (msg.error.indexOf('wrong pin') > -1 && msg.error_code !== 433) ||
                                (('' + msg.error).match(/^User ID \w+ already exists$/) && msg.error_code !== 436) ||
                                (('' + msg.error).match(/unpublish, not published$/) && msg.error_code !== 435) ||
                                (('' + msg.error).match(/^Maximum number of publishers/) && msg.error_code !== 432)
                            ) {
                                logger.log(
                                    'startVideoPublish->janus.attach.onmessage',
                                    'incorrect error_code/error combination',
                                    msg.error_code,
                                    msg.error
                                );
                            }

                            if (!self.handleVideoPublishPluginError(msg)) {
                                return;
                            }

                            if (self.republishing) {
                                self.republishing = false;
                            }

                            if (self.sendRestartVideo) {
                                self.sendRestartVideo = false;
                            }
                        }
                    }

                    // handle SDP if present
                    if (jsep) {
                        handleVideoPublishJSEP(msg, jsep);
                    }
                },
                onlocalstream: function (stream) {
                    // local stream is obtained, then display the local video element.
                    logService.log('videoroomCtrl videoroom publisher local stream');

                    var sameStream = self.mystream === stream;

                    self.mystream = stream;
                    logService.log(stream);

                    var enabled = self.mediapath != 'sfu' || self.videoEnabled; // enabled used only mediapath of 'sfu'
                    var div = self.createVideoElement(enabled, stream);
                    $window.$(div).attr('playing', true);

                    self.createVideoBitrateControl();

                    if (self.mediapath == 'sfu') {
                        // use audio track too if mediapath is 'sfu'

                        // overwriteLocalStream will stop video tracks, but we shouldn't do it when switch audio device.
                        if (!sameStream) {
                            // localStreamManagerService will have its own stream with unique ID
                            // we will add the same video track to this stream a few lines below
                            localStreamManagerService.overwriteLocalStream(stream.clone());
                        }

                        var audioTracks = stream.getAudioTracks();
                        try {
                            audioTracks[0].enabled = self.cdrAudioEnabled;
                        } catch (e) {
                            // ignore
                        }
                        if (audioTracks != null && audioTracks.length > 0) {
                            localStreamManagerService.replaceLocalAudioTrack(audioTracks[0]);
                        }

                        // used for prevent appearing red exclamation mark when switching microphone
                        avDeviceService.setIsMicrophoneDeviceSwitching(false);

                        // Cloned stream used for local audio level tracking while muted
                        localStreamManagerService.setClonedAudioStream(stream);

                        if (self.e2ee) {
                            self.e2eeSetupSender(plugin, stream);
                        }
                    } else {
                        // localStreamManagerService will have its own stream with unique ID
                        // we will add the same video track to this stream a few lines below
                        localStreamManagerService.overwriteLocalStream(stream.clone());
                    }

                    var videoTracks = stream.getVideoTracks();
                    if (videoTracks === null || videoTracks === undefined || videoTracks.length === 0) {
                        logger.warn('startVideoPublish->janus.attach.onlocalstream', 'no video track');
                    } else {
                        var videoTrackSettings =
                            videoTracks[0] && videoTracks[0].getSettings ? videoTracks[0].getSettings() : null;
                        if (videoTrackSettings && videoTrackSettings.deviceId) {
                            logService.log(
                                'videoroomCtrl videoroom publisher, video track deviceId: ' +
                                    videoTrackSettings.deviceId
                            );

                            // videoTrackSettings.deviceId is different from currently selected webcam if VB enabled
                            const webcam = avDeviceService.getCurrentlySelectedWebcam();
                            const deviceId = webcam ? webcam.deviceId : videoTrackSettings.deviceId;

                            if (avDeviceService.getSfuDeviceErrorFromId(deviceId)) {
                                avDeviceService.clearSfuDeviceError(deviceId);
                            }

                            $rootScope.$broadcast('janus-local-media-stream-created', { type: 'video' });
                        }

                        if (self.useSimulcast2 && self.simulcastFlag && videoTrackSettings) {
                            if (
                                !self.verifyConstraintsForSimulcast2(
                                    videoTrackSettings.width,
                                    videoTrackSettings.height
                                )
                            ) {
                                logger.error(
                                    'startVideoPublish->janus.attach.onlocalstream',
                                    'failed to verify constraints for simulcast2 (' +
                                        videoTrackSettings.width +
                                        'x' +
                                        videoTrackSettings.height +
                                        '), disabling simulcast2'
                                );
                                self.msgflowEvent('simulcast2:disabled', {
                                    reason: 'constraints',
                                    width: videoTrackSettings.width,
                                    height: videoTrackSettings.height
                                });
                                $timeout(function () {
                                    self.useSimulcast2 = false;
                                    self.createOfferOrRepublish();
                                }, 2000);
                            }
                        }
                        if (self.enablePortraitRecord && videoTrackSettings) {
                            logger.log(
                                'startVideoPublish->janus.attach.onlocalstream',
                                `Local captured video resolution : ${videoTrackSettings.width}x${videoTrackSettings.height}`
                            );
                            socketService.send({
                                message: 'sfu-video-size',
                                data: { height: videoTrackSettings.height, width: videoTrackSettings.width }
                            });
                        }

                        //Calling replaceLocalVideoTrack will make sure the video track has an ended event listener
                        //and an event gets broadcasted to other services/controllers
                        localStreamManagerService.replaceLocalVideoTrack(videoTracks[0]);

                        try {
                            videoTracks[0].contentHint = 'motion';
                        } catch (err) {
                            logger.warn(
                                'startVideoPublish->janus.attach.onlocalstream',
                                'failed to set contentHint for video stream',
                                err
                            );
                        }

                        logService.log(
                            'videoroomCtrl sending attendee-mediastats for videoIn: ' + videoTracks[0].label
                        );
                        socketService.send({
                            message: 'attendee-mediastats',
                            data: { videoIn: videoTracks[0].label }
                        });

                        self.deviceUpdateEventToMsgFlow('local-stream', { video: { trackId: videoTracks[0].id } });
                    }

                    // if video is not enabled, then stop local video track
                    // it protects us from ANYAM-73545 Webcam light is not off when camera off in sfu meeting
                    if (self.mediapath == 'sfu' && !self.videoEnabled) {
                        localStreamManagerService.stopLocalVideoTrack();
                    }
                },
                onremotestream: function (stream) {
                    // The publisher stream is sendonly, we don't expect anything here
                    logService.log('videoroomCtrl videoroom publisher remote stream');
                    logService.log(stream);
                },
                ondetached: function () {
                    var plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl publish, ignoring ondetached as not for current plugin');
                        return;
                    }

                    logger.warn(
                        'startVideoPublish->janus.attach.ondetached',
                        'videoroom publisher, got forced detached from server, we stop video publish'
                    );
                    // timeout needed to delay our detach(withRequest) after detach(noRequest) of janus.js to avoid error from server
                    $timeout(function () {
                        self.setVideoPublishState('button', false);

                        self.stopVideoPublish();
                    }, 0);
                },
                oncleanup: function () {
                    // when the plugin handle is cleaned up, remove the local video element.
                    logService.log(
                        'videoroomCtrl videoroom publisher, received cleanup notification, republishing=' +
                            self.republishing
                    );
                    plugin.state.call = 'closed';

                    var plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl publish, ignoring oncleanup as not for current plugin');
                        return;
                    }

                    if (plugin.timerUnpublish) {
                        $timeout.cancel(plugin.timerUnpublish);
                        delete plugin.timerUnpublish;
                    }

                    self.mystream = null;

                    delete plugin._configured;

                    if (
                        !self.republishing &&
                        !self.pendingCreateOfferForVideo &&
                        self.videoroom &&
                        !self.videoroom.detaching
                    ) {
                        // this is an unrequested cleanup.
                        plugin.cleanupRetry = (plugin.cleanupRetry || 0) + 1; // this never gets reset, since there is no suitable place/condition to reset this.
                        if (plugin.cleanupRetry <= self.cleanupRetryMax) {
                            logService.log(
                                'videoroomCtrl videoroom publisher, unrequested cleanup, creating offer again after 2s.'
                            );
                            $timeout(function () {
                                // if the condition is still valid after 2 seconds, continue with create offer again.
                                if (
                                    !helperService.getIsMeetingEnding() &&
                                    !self.republishing &&
                                    !self.pendingCreateOfferForVideo &&
                                    self.videoroom &&
                                    self.videoroom === plugin &&
                                    !plugin.detaching
                                ) {
                                    self.createOfferForVideo();
                                } else {
                                    logService.log('videoroomCtrl videoroom publisher, aborting create offer');
                                }
                            }, 2000);
                        } else {
                            logger.error(
                                'startVideoPublish->janus.attach.oncleanup',
                                'videoroom publisher, failed to create peer connection, aborting'
                            );
                            self.showAlert(
                                'Failed to publish your video, please reload the application and try again',
                                'Unexpected Failure'
                            );
                            $timeout(function () {
                                // timeout needed to avoid calling oncleanup within oncleanup.
                                self.stopVideoPublish();
                            });
                        }
                    } else if (self.pendingCreateOfferForVideo) {
                        // continue createOfferForVideo here. should be before check to remove video elements.
                        logService.log('videoroomCtrl videoroom publisher, continue with create offer from pending');
                        var args = self.pendingCreateOfferForVideo;
                        self.pendingCreateOfferForVideo = null;
                        self.msgflowEvent('peer-connection:pending', { type: 'video-send', reason: 'pending' });
                        self.createOfferForVideo(args[0], args[1], true);
                    } else if (!self.republishing) {
                        // do not cleanup local view if republishing
                        logService.log('videoroomCtrl videoroom publisher, cleanup local view');
                        self.removeVideoElement();
                        self.destroyVideoBitrateControl();
                        self.destroyAltVideoBitrateControl();
                        videoFilterService.stopVideoFilterStream();
                        self.stopFaceTrackStream();
                        self.stopVideoCanvasStream();
                    } else {
                        logService.log('videoroomCtrl videoroom publisher, do not cleanup local view');
                    }
                    self.iceRestartCancel(self.videoroom);
                }
            });
        }

        // for backward compatibility (remove later)
        function onUpdateMeetingActiveFeed() {
            if (attendeeService.getIsSfuEnabled()) {
                if (!self.setVideoPublishState('button', false)) {
                    // ANYAM-107874: update webcam button state when join with video
                    $rootScope.$broadcast('update-local-video-state');
                }
            }
        }

        function sendVideoMute(value) {
            self.setVideoPublishState('server', true);
            socketService.send({
                message: 'sfu-video-mute',
                data: self.getSfuVideoMuteData(value),
                callback: function () {
                    self.setVideoPublishState('server', false);
                }
            });
        }

        function setVideoPublishState(type, value) {
            self.videoPublishState[type] = value;

            if ((self.fixWebcamButtonState && type === 'server') || (!self.fixWebcamButtonState && type === 'button')) {
                if (value || attendeeService.getIsWaitingForVideoUpdate()) {
                    attendeeService.setIsWaitingForVideoUpdate(value, true);
                    return true;
                }
            }

            return false;
        }

        // After user ID already exists error is received either for screen share or video, none of the other requests work
        // anymore, even after kick-from-videoroom is done. So the step is to first kick-from-videoroom, and then join the session
        // without destroying janus.
        function onErrorUserIdAlreadyExists(is_video, is_screen, plugin) {
            logger.log(
                'onErrorUserIdAlreadyExists',
                `will kick-from-videoroom and retry: video=${!!is_video}, screen share=${!!is_screen}`
            );

            plugin.pendingRestart = true;

            let requestTimer = $timeout(function () {
                requestTimer = null;

                analyticsWrapperService.eventTrack(
                    'Meeting - video publish - stopped kick-from-videoroom callback not received.'
                );

                // show 'video' in the text of alert if both video and screen are passed
                self.showAlert(self.getContentShareErrorMessage(is_screen && !is_video, false));

                if (is_screen) {
                    $rootScope.$broadcast('stop-sfu-screenshare');
                }
            }, 10000);

            socketService.send({
                message: 'kick-from-videoroom',
                data: { video: !!is_video, screen: !!is_screen, fileplay: self.fileplay },
                callback: function (result) {
                    if (requestTimer) {
                        $timeout.cancel(requestTimer);
                        requestTimer = null;
                    } else if (requestTimer === null) {
                        return;
                    }

                    logger.log('onErrorUserIdAlreadyExists', `after kick-from-videoroom, continue=${result}`);

                    if (result) {
                        // join without checking if room exists
                        if (is_screen) {
                            self.joinScreenPublisherToRoom();
                        } else {
                            self.joinVideoPublisherToRoom();
                        }
                    } else {
                        delete plugin.pendingRestart;
                        logger.error('onErrorUserIdAlreadyExists', 'failed to kick-from-videoroom');
                        self.showAlert(self.getContentShareErrorMessage(is_screen, false));
                    }
                }
            });
        }

        function republishAfterSimulcastChanged() {
            if (!self.videoroom) {
                return;
            }

            // continue only if vp8 or h264 is being used.
            if (
                !self.videocodec ||
                self.videocodec == 'vp8' ||
                self.videocodec == 'h264' ||
                (self.videocodec == 'auto' && self.sendVideoToFS)
            ) {
                logger.log(
                    'republishAfterSimulcastChanged',
                    're-creating offer or re-publishing video to switch simulcast mode'
                );

                self.msgflowEvent('peer-connection:simulcast', {
                    type: 'video-send',
                    reason: 'simulcast changed',
                    enabled: self.simulcastFlag
                });

                self.destroyAltVideoBitrateControl();
                self.createOfferOrRepublish();
            }
        }

        // it passes all the params to createOfferForVideo as applicable.
        // This should be preferred over createOfferForVideo, whenever custom stream (e.g., blur bg) is allowed,
        // and createOfferForVideo could be called multiple times.
        function createOfferOrRepublish() {
            if (!self.videoroom.hasCustomStream) {
                logService.log('videoroomCtrl createOffer');
                self.createOfferForVideo.apply(self, arguments);
            } else {
                // above does not work for videoFilter or other custom stream, so republish.
                logService.log('videoroomCtrl republish');
                self.republishing = true;
                self.stopVideoPublish();
                self.startVideoPublish();
            }
        }

        // send offer for video publish in the video room.
        // If firstTime is not set, then this sets the republishing state. For firstTime, it
        // also continues with video-unmute process.
        // If callback is supplied, it is invoked on success or failure.
        // If fromPending is supplied, then it won't put it back in pending queue.
        // For republishing, it first unpublishes, waits for it to complete, and then republishes.
        // But if a previous request is waiting, it does not send another unpublish.
        function createOfferForVideo(firstTime, callback, fromPending, iceRestart, mediaConstraintsType) {
            if (!firstTime && !fromPending) {
                logService.log(
                    'videoroomCtrl videoroom publisher create offer not first time not from pending, pending=' +
                        !!self.pendingCreateOfferForVideo
                );

                self.republishing = true;
                if (self.pendingCreateOfferForVideo) {
                    // already has another pending request
                    if (callback && !self.pendingCreateOfferForVideo[1]) {
                        // store callback
                        self.pendingCreateOfferForVideo[1] = callback;
                    }
                    return;
                } else if (self.mediapath != 'sfu') {
                    delete self.videoroom.retryUnpublish; // remove previous retry state if any
                    sendToVideoPublishPlugin({ message: { request: 'unpublish' } });
                    // continue after unpublish completes.
                    self.pendingCreateOfferForVideo = [firstTime, callback];
                    return;
                }
            }

            logService.log(
                'videoroomCtrl videoroom publisher create offer. firstTime' + firstTime + ', fromPending=' + fromPending
            );

            var useSimulcast2 = false;
            if (self.useSimulcast2 === null) {
                useSimulcast2 =
                    $window.Janus.webRTCAdapter.browserDetails.browser === 'chrome' &&
                    $window.Janus.webRTCAdapter.browserDetails.version >= 77;
            } else {
                useSimulcast2 = !!self.useSimulcast2;
            }

            self.sendRestartVideo = false;

            if (self.fixVideoFilterForSimulcast2) {
                // apply simulcast2 constraints to videoFilter, faceTrack and videoCanvas modules, if needed.
                self.applyConstraintsForSimulcast2();
            }

            var stream;
            if (self.mediapath != 'sfu' || self.videoEnabled) {
                stream =
                    videoFilterService.startVideoFilterStream(
                        self.getMediaConstraints,
                        undefined,
                        undefined,
                        videoFilterService.onStartVideoFilterComplete,
                        function (reason, userStream) {
                            logService.log('videoroomCtrl customize stream callback. reason: ' + reason);
                            if (self.mediapath == 'sfu') {
                                var audioTracks = userStream && userStream.getAudioTracks();
                                if (audioTracks && audioTracks.length > 0) {
                                    stream.addTrack(audioTracks[0]);
                                }

                                self.createOfferInternal(
                                    firstTime,
                                    callback,
                                    iceRestart,
                                    mediaConstraintsType,
                                    useSimulcast2,
                                    stream
                                );
                            }
                        }
                    ) || self.startFaceTrackStream();

                stream = self.startVideoCanvasStream(stream);
            }

            self.videoroom.hasCustomStream = !!stream;

            if (self.willSwitchDevice) {
                self.willSwitchDevice = false;
                avDeviceService.setIsMicrophoneDeviceSwitching(true);
            }

            if (!stream || self.mediapath != 'sfu') {
                self.createOfferInternal(firstTime, callback, iceRestart, mediaConstraintsType, useSimulcast2, stream);
            }
        }

        function createOfferInternal(firstTime, callback, iceRestart, mediaConstraintsType, useSimulcast2, stream) {
            logService.log('videoroomCtrl createOfferInternal: has stream = ' + !!stream);

            if (self.flagsObject) {
                self.flagsObject.hasCustomStream = self.videoroom.hasCustomStream;
            }

            const plugin = self.videoroom;

            self.videoroom.createOffer({
                iceRestart: !!iceRestart,
                media: self.getMediaConstraints(mediaConstraintsType || (firstTime ? 'video' : 'video-change')),
                stream: stream, // will be undefined unless videoFilter is present
                simulcast: useSimulcast2 ? undefined : self.simulcastFlag,
                simulcast2: useSimulcast2 ? self.simulcastFlag : undefined,
                success: function (jsep) {
                    const plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.warn(
                            'createOfferInternal->videoroom.createOffer.success',
                            'ignoring success as not for current plugin'
                        );

                        return;
                    }

                    logService.log('videoroomCtrl videoroom got publisher SDP!');
                    logService.log(jsep);

                    var bitrate = (self.videoroom.state.bitrate = self.getVideoBitrate());
                    var publish = { request: 'configure', audio: true, video: true, bitrate: bitrate };

                    // set the videocodec attribute if needed.
                    if (self.videocodec && self.videocodec != 'vp8') {
                        publish.videocodec =
                            self.videocodec != 'auto' ? self.videocodec : self.sendVideoToFS ? 'vp8' : 'vp9';
                        self.videoroom.state.videocodec = publish.videocodec;
                    }
                    if (self.isVideoPublishOfferPending) {
                        self.isVideoPublishOfferPending = false;
                    } else {
                        // another createOffer will cause sendRestartVideo to be true.
                        if (self.mediapath != 'sfu' || firstTime) {
                            self.sendRestartVideo = true;
                        }
                    }

                    sendToVideoPublishPlugin({ message: publish, jsep: jsep });

                    if (firstTime && self.mediapath != 'sfu') {
                        // continue to unvmute
                        attendeeService.setIsVideoMuted(false);
                        self.sendVideoMute(false);
                    }

                    // ANYAM-80571 Windows default audio device is selected after attendee reconnect in e2ee meeting
                    // Need update audio output device explicitly.
                    if (self.mediapath === 'sfu') {
                        logService.log('videoroomCtrl createOfferInternal: success => update audio output device');
                        $rootScope.$broadcast('update-audio-output');
                    }

                    if (typeof callback === 'function') {
                        callback(true);
                    }
                },
                error: function (error) {
                    const plugin0 = self.videoroom;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.warn(
                            'createOfferInternal->videoroom.createOffer.error',
                            'ignoring error as not for current plugin',
                            error
                        );

                        return;
                    }

                    logger.error(
                        'createOfferInternal->videoroom.createOffer.error',
                        'videoroom publisher WebRTC error',
                        error
                    );

                    if (self.republishing) {
                        self.republishing = false;
                    }
                    var additionalInfo = '';
                    if (error && (error.name === 'NotReadableError' || error.name === 'NotAllowedError')) {
                        additionalInfo = 'NotReadableError';
                    }

                    self.willSwitchDevice = false;
                    avDeviceService.setIsMicrophoneDeviceSwitching(false);

                    self.setVideoPublishState('button', false);
                    avDeviceService.setSfuDeviceError(
                        storageService.get('video-device'),
                        error && error.name ? error.name : error
                    );

                    self.isVideoPublishOfferPending = false;
                    self.stopVideoPublish();

                    if (additionalInfo === 'NotReadableError') {
                        self.showDeviceInUseAlert();
                    } else {
                        self.showAlert(localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM'));
                    }

                    videoFilterService.stopVideoFilterStream();
                    self.stopFaceTrackStream();
                    self.stopVideoCanvasStream();
                    if (typeof callback === 'function') {
                        callback(false);
                    }
                },
                customizeSdp: function (jsep) {
                    // do not set min, max, start bitrate for simulcast, but let simulcast logic decide that.
                    self.customizeSdp(jsep, self.simulcastFlag);
                },
                e2ee: !!self.e2ee,
                rtcConstraints: self.rtcConstraintsVideo || undefined,
                simulcastEncodings: useSimulcast2 && self.simulcastFlag ? self.getSimulcastEncodings() : undefined,
                simulcastMaxBitrates: self.bitrate.substream || undefined // not used if useSimulcast2 == false
            });
        }

        function onStartSfuVideoPublish() {
            logService.log('videoroomCtrl starting SFU video publish');
            self.msgflowEvent('unmute video');

            self.setVideoPublishState('button', true);

            if (self.mediapath == 'sfu') {
                // create new offer that includes video track.
                self.videoEnabled = true;
                self.msgflowEvent('peer-connection:unmute', {
                    type: 'video-send',
                    reason: 'mediapath sfu video unmute'
                });
                self.createOfferOrRepublish(self.videoEnabledFirstTime, function (status) {
                    self.videoEnabledFirstTime = false;
                    if (status) {
                        attendeeService.setIsVideoMuted(false);
                        self.sendVideoMute(false);
                    }
                });
            } else if (self.layoutPage && (self.videoroom || self.pendingPublishAttach)) {
                logService.log(
                    'videoroomCtrl publisher attach ignored on unmute, as previous request is pending (' +
                        self.pendingPublishAttach +
                        ') or already active (' +
                        !!self.videoroom +
                        ')'
                );
                self.msgflowEvent('publish:attach:error', {
                    reason: self.videoroom ? 'already active' : 'previous pending'
                });
            } else {
                self.isVideoPublishOfferPending = true;
                self.resetIceRestartState('video-send');
                self.startVideoPublish();

                if (self.testvideos) {
                    self.testvideosStartPublish();
                }
            }
        }

        function onStopSfuVideoPublish(e, justCleanUp) {
            logService.log('videoroomCtrl stopping SFU video publish');
            self.msgflowEvent('mute video');

            self.setVideoPublishState('button', true);

            if (self.mediapath == 'sfu') {
                // create new offer that excludes video track.
                self.videoEnabled = false;

                if (!justCleanUp) {
                    attendeeService.setIsVideoMuted(true);
                    self.sendVideoMute(true);
                }

                self.msgflowEvent('peer-connection:mute', { type: 'video-send', reason: 'mediapath sfu video mute' });
                self.createOfferOrRepublish();
            } else {
                self.isVideoPublishOfferPending = false;
                if (self.testvideos) {
                    self.testvideosStopPublish();
                }
                self.resetIceRestartState('video-send');
                self.stopVideoPublish();
            }
        }

        // video filter related code.

        // value changed from audio/video settings
        function onVideoFilterChanged(evt, msg) {
            logService.log('videoroomCtrl video-filter-changed', msg);
            if (self.videoroom) {
                self.stopVideoPublish();
                self.startVideoPublish();
            }
        }

        function getContentShareErrorMessage(isScreen, isSip) {
            if (isScreen) {
                if (self.fileplay) {
                    return localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_SHARING_VIDEO_FILE');
                } else {
                    return localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_SHARING_SCREEN');
                }
            }
            return isSip
                ? localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_SHARING_MEDIA')
                : localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_SHARING_VIDEO');
        }

        function checkRoomExistsAndJoin() {
            sendToVideoPublishPlugin({
                message: { request: 'exists', room: self.myroom },
                success: function (msg) {
                    if (msg.exists !== undefined && self.videoroom) {
                        if (msg.exists && !self.testForceNoRoom) {
                            self.joinVideoPublisherToRoom();
                        } else {
                            logger.error(
                                'checkRoomExistsAndJoin',
                                `Room does not exist, retrying request in ${self.timeoutCheckRoomExists} ms`,
                                self.myroom
                            );

                            // ANYAM-98792: workaround for Janus room creation
                            if (!self.roomCreationRequested) {
                                self.roomCreationRequested = true;

                                logger.log(
                                    'checkRoomExistsAndJoin',
                                    'Room does not exist => try to create it',
                                    self.myroom
                                );

                                socketService.send({ message: 'create-videoroom-if-needed' });
                            }

                            if (self.timerCheckRoomExists) {
                                $timeout.cancel(self.timerCheckRoomExists);
                                self.timerCheckRoomExists = null;
                            }

                            self.timerCheckRoomExists = $timeout(function () {
                                self.timerCheckRoomExists = null;
                                self.checkRoomExistsAndJoin();
                            }, self.timeoutCheckRoomExists);
                        }
                    } else {
                        logger.warn(
                            'checkRoomExistsAndJoin',
                            `can not start video publish: msg.exists=${!!msg.exists}; has videoroom plugin=${!!self.videoroom}`
                        );
                    }
                }
            });
        }

        function getVideoPublishRegisterObj() {
            const register = {
                request: 'join',
                room: self.myroom,
                ptype: 'publisher',
                display: self.myusername
            };
            self.addPublisherIdToRequest(register);
            self.addPinToRequest(register);

            return register;
        }

        function joinVideoPublisherToRoom() {
            self.videoroom.state.call = 'joining';
            const register = self.getVideoPublishRegisterObj();
            sendToVideoPublishPlugin({ message: register });
        }

        function sendToVideoPublishPlugin(callbacks) {
            if (callbacks.error === undefined) {
                callbacks.error = msg => {
                    logger.error('sendToVideoPublishPlugin', 'initial message', callbacks.message, 'response', msg);
                    self.handleVideoPublishPluginError(msg);
                };
            }

            if (self.videoroom) {
                self.videoroom.send(callbacks);
            }
        }

        function handleVideoPublishPluginError(msg) {
            switch (msg.error_code) {
                case 424: // JANUS_VIDEOROOM_ERROR_JOIN_FIRST
                case 425: // JANUS_VIDEOROOM_ERROR_ALREADY_JOINED
                case 426: // JANUS_VIDEOROOM_ERROR_NO_SUCH_ROOM
                case 434: // JANUS_VIDEOROOM_ERROR_ALREADY_PUBLISHED
                case 437: // JANUS_VIDEOROOM_ERROR_INVALID_SDP
                case 459: // JANUS_ERROR_HANDLE_NOT_FOUND
                case 461: // JANUS_ERROR_PLUGIN_ATTACH
                case 462: // JANUS_ERROR_PLUGIN_MESSAGE (Request prohibitied by AnyMeeting)
                case 466: // JANUS_ERROR_TRICKE_INVALID_STREAM
                case 469: // JANUS_ERROR_UNEXPECTED_ANSWER
                case 471: // JANUS_VIDEOROOM_ERROR_ALREADY_BACKEND
                case 473: // JANUS_ERROR_PLUGIN_SESSION_NOT_FOUND
                case 500: // JANUS_ERROR_INTERNAL_ERROR
                case 502: // JANUS_ERROR_BAD_GATEWAY
                case 503: // JANUS_ERROR_SERVICE_UNAVAILABLE
                case 504: // JANUS_ERROR_GATEWAY_TIMEOUT
                    self.recreateVideoPublishPlugin();
                    return false;
                case 432: // JANUS_VIDEOROOM_ERROR_PUBLISHERS_FULL
                    handleMaximumNumberOfPublishersError();
                    break;
                case 433: // JANUS_VIDEOROOM_ERROR_UNAUTHORIZED
                    handleWrongPinError();
                    break;
                case 435: // JANUS_VIDEOROOM_ERROR_NOT_PUBLISHED
                    if (handleNotPublishedError()) {
                        return false; // do not reset republishing or sendRestartVideo
                    }
                    break;
                case 436: // JANUS_VIDEOROOM_ERROR_ID_EXISTS
                    handleUserIdAlreadyExistsError();
                    break;
                case 470: // JANUS_VIDEOROOM_ERROR_ALREADY_DESTROYED
                case 499: // JANUS_VIDEOROOM_ERROR_UNKNOWN_ERROR
                    rejoinVideoPublishConference(msg);
                    return false;
                default:
                    break;
            }

            return true;
        }

        function recreateVideoPublishPlugin() {
            if (self.rejoinConferenceTimer) {
                logger.log('recreateVideoPublishPlugin', 'will not retry because we are in the rejoining state');
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: self.videoRepublishRetry,
                limit: self.videoRepublishMaxRetries,
                success: timeoutLength => {
                    logger.log('recreateVideoPublishPlugin', `will retry in ${timeoutLength} ms`);

                    self.videoRepublishRetry += 1;
                    self.cancelVideoRepublishTimer();

                    self.videoRepublishTimer = $timeout(function () {
                        self.videoRepublishTimer = null;

                        if (self.rejoinConferenceTimer) {
                            logger.log(
                                'recreateVideoPublishPlugin->retryWithExponentialBackoffAndLimit->success',
                                'will not retry because we are in the rejoining state'
                            );
                            return;
                        }

                        if (self.videoroom) {
                            self.republishing = true;
                            self.stopVideoPublish();
                        }

                        self.startVideoPublish();
                    }, timeoutLength);
                },
                error: () => {
                    self.showAlert(
                        localizationService.translate('SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_VIDEO')
                    );

                    if (self.videoroom) {
                        self.stopVideoPublish();
                    }
                }
            });
        }

        function rejoinVideoPublishConference(msg) {
            if (self.rejoinConferenceTimer) {
                logger.log('rejoinVideoPublishConference', 'will not retry because we are in the rejoining state');
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: self.videoRepublishRetry,
                limit: self.videoRepublishMaxRetries,
                success: timeoutLength => {
                    self.videoRepublishRetry += 1;
                    self.prepareForRejoinConference();
                    self.rejoinConferenceAfter(msg.error, timeoutLength, undefined, true);
                },
                error: () => {
                    self.showAlert(
                        localizationService.translate('SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_VIDEO')
                    );
                    self.prepareForRejoinConference();
                    $rootScope.$broadcast('sfu-ws-gave-up');
                }
            });
        }

        function handleVideoPublishJSEP(msg, jsep) {
            logger.log('handleVideoPublishJSEP', 'videoroom handling SDP as well...', jsep);

            self.customizeSdp(jsep, self.simulcastFlag, undefined, undefined, true);

            self.videoroom.handleRemoteJsep({ jsep: jsep });
            if (self.republishing) {
                self.republishing = false;
            }

            var audio = msg.audio_codec;
            if (
                self.mystream &&
                self.mystream.getAudioTracks() &&
                self.mystream.getAudioTracks().length > 0 &&
                !audio
            ) {
                logger.error(
                    'handleVideoPublishJSEP',
                    'videoroom our audio stream has been rejected, viewers will not hear us'
                );
            }

            var video = msg.video_codec;
            if (
                self.mystream &&
                self.mystream.getVideoTracks() &&
                self.mystream.getVideoTracks().length > 0 &&
                !video
            ) {
                logger.error(
                    'handleVideoPublishJSEP',
                    'videoroom our video stream has been rejected, viewers will not see us'
                );
            }
        }

        function cancelVideoRepublishTimer() {
            if (self.videoRepublishTimer) {
                $timeout.cancel(self.videoRepublishTimer);
                self.videoRepublishTimer = null;
            }
        }

        function handleMaximumNumberOfPublishersError() {
            if (self.layoutPage && self.mediapath !== 'sfu') {
                self.showAlert(localizationService.translate('SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_VIDEO'));

                $timeout(function () {
                    self.setVideoPublishState('button', false);

                    self.republishing = false;
                    self.isVideoPublishOfferPending = false;
                    self.resetIceRestartState('video-send');
                    self.stopVideoPublish();
                });
            }
        }

        function handleWrongPinError() {
            //This error shouldn't happen because Node send new pin after updating it
            //But we add this as a fallback path just in case client didn't receive initial Node event
            self.setVideoPublishState('button', false);

            socketService.send({ message: 'request-videoroom-pin' });

            self.showAlert(localizationService.translate('SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_VIDEO'));

            self.stopVideoPublish();
        }

        // returns true to abort next steps in caller.
        function handleNotPublishedError() {
            const plugin = self.videoroom;

            // this can happen in race condition ANYAM-67538 when createOfferForVideo was called second time when first time didn't complete.
            if (self.pendingCreateOfferForVideo && (plugin.retryUnpublish || 0) < 4) {
                // retry at most four times.
                plugin.timeoutUnpublish = Math.round(1000 * (Math.random() - 0.5) + 2000);

                logService.log(
                    'videoroomCtrl videoroom will try unpublish again soon: ' +
                        plugin.retryUnpublish +
                        ', after: ' +
                        plugin.timeoutUnpublish
                );

                if (plugin.timerUnpublish) {
                    $timeout.cancel(plugin.timerUnpublish);
                    delete plugin.timerUnpublish;
                }

                plugin.timerUnpublish = $timeout(function () {
                    delete plugin.timerUnpublish;
                    if (self.pendingCreateOfferForVideo) {
                        plugin.retryUnpublish = (plugin.retryUnpublish || 0) + 1;
                        self.republishing = true;
                        logService.log(
                            `videoroomCtrl videoroom sending delayed unpublish, retry=${plugin.retryUnpublish}`
                        );
                        sendToVideoPublishPlugin({ message: { request: 'unpublish' } });
                    } else {
                        logService.log(
                            'videoroomCtrl videoroom not sending delayed unpublish, no pending offer needed'
                        );
                    }
                }, plugin.timeoutUnpublish); // randomized time 1.5-2.5 second.

                return true;
            } else if (self.pendingCreateOfferForVideo) {
                // ANYAM-70586 - continue with regular create offer without pending.
                logService.log('videoroomCtrl videoroom continue with create offer from pending');

                var args = self.pendingCreateOfferForVideo;
                self.pendingCreateOfferForVideo = null;
                self.msgflowEvent('peer-connection:pending', {
                    type: 'video-send',
                    reason: 'pending'
                });
                self.createOfferForVideo(args[0], args[1], true);

                return true;
            }

            return false;
        }

        function handleUserIdAlreadyExistsError() {
            self.setVideoPublishState('button', false);

            // This can happen if Janus has screen share participant, but client was reconnecting, due to network change
            // Note: in case of Janus supports 'claim' request we'll got this error two times after refresh the page.
            // First for video publisher (handle it here) and second for screen publisher (handle it in videoScreenShareService).
            self.onErrorUserIdAlreadyExists(true, false, self.videoroom);
        }
    }
]);
